export const QUOTE_STATUS_OPTIONS = [
  { value: "Pendente", label: "Pendente" },
  { value: "Stand-by", label: "Stand-by" },
  { value: "Simulado", label: "Aprovado" },
  { value: "Realizado", label: "Realizado" },
];

export const getQuoteStatusLabel = (status) =>
  QUOTE_STATUS_OPTIONS.find((option) => option.value === status)?.label || status || "—";
